export const connectionTypes = {
    API_KEY: 'API_KEY',
    CUSTOM: 'CUSTOM',
    OAUTH2: 'OAUTH2',
};
